import './style/index.js';

import _Badge from './Badge';

export type { BadgeProps } from './Badge';
export * from './type';

export const Badge = _Badge;
export default Badge;
